export const ArenaSymbols = {
    ArenaService: Symbol.for("ArenaService"),
    ArenaProvider: Symbol.for("ArenaProvider")
}